"use strict";

import module from "./module";

import "./filesize.pipe.spec.js";

export default module;
